import * as React from 'react';
import type { SVGProps } from 'react';

const SvgKs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="m1147 649.79-7.512-200.88-39.145-16.047-19.62-38.656-11.782-17.363 18.97-35.594-5.282-26.996-18.758 1.14-35.234-23.698-198.7 5.953-332.07 3.246-187.67-1.914-252.23-6.762-.246.008-9.14 288.98-10.216 275.35 141.71 4.199 150.44 2.941 150.56 1.2 271.09-1.914 270.86-7.204 131.97-5.527z" />
  </svg>
);
export default SvgKs;
